import React, {useState} from 'react'
import {Style} from './style/Tree'
import InputField from '../../module/input'
import Button from '../../module/button'
import File from '../../module/file'

const Tree = (props: any) => {

  const {item, hasChildren, level, toggle, add, modify, _delete} = props
  const [isModify, setIsModify] = useState(false)
  const [isAdd, setIsAdd] = useState(false)
  const [state, setState] = useState<any>({})

  const handleChange = (e: any) => {
    setState({
      ...state,
      [e.target.name]: e.target.value
    })
  }

  return (
    <Style.Container>
      <Style.Tree>
        {
          !isModify ?
            <>
              <input
                type="checkbox"
                id={item.id}
                onChange={toggle}
                defaultChecked={false}
              />
              <label htmlFor={item.id}>
                <span style={{'paddingLeft': level * 5}}>
                  {item.name}
                  {/*<span className="url">{item.url}</span>*/}
                </span>
              </label>
            </>
            :
            <>
              <Style.TreeItem isLevel={level}>
                <InputField
                  type="text"
                  id="name"
                  name="name"
                  value={state.name ? state.name : item.name}
                  placeholder=""
                  onChange={(e) => handleChange(e)}
                />

                <InputField
                  type="text"
                  id="code"
                  name="code"
                  value={state.code !== undefined ? state.code : (item.code || '')}
                  placeholder="카테고리 코드"
                  onChange={(e) => handleChange(e)}
                />

                <InputField
                  type="number"
                  id="order"
                  name="order"
                  value={state.order !== undefined ? state.order : (item.order || '')}
                  placeholder="노출 순서"
                  onChange={(e) => handleChange(e)}
                />

                <File
                  id={`category-image-${item.id}`}
                  name={`category-image-${item.id}`}
                  isTransform={false}
                  placeholder={state.image?.name || '카테고리 이미지 업로드'}
                  thumbnail={state.image?.thumb || (item.image ? process.env.REACT_APP_BASE_URL + item.image : '')}
                  accept={'.jpg,.jpeg,.png'}
                  onChange={(file: any) => setState({
                    ...state,
                    image: {
                      file: file.file,
                      thumb: file.thumb,
                      name: file.file.name
                    }
                  })}
                />
              </Style.TreeItem>
            </>
        }

        {
          hasChildren && <span className="icon icon-arrow-down">-</span>
        }

        <Style.Action>
          {
            isModify ?
              <Style.ModyfiAction>
                <Button
                  margin={'0 .4rem 0 .4rem'}
                  padding={'.4rem .5rem'}
                  radius={'.5rem'}
                  bgcolor={'#3f3b3f'}
                  color={'#ffffff'}
                  themecolor={'dark-gray'}
                  onClick={() => [modify({
                    id: item.id,
                    name: state.name !== undefined ? state.name : item.name,
                    code: state.code !== undefined ? state.code : item.code,
                    order: state.order !== undefined ? state.order : item.order,
                    image: state.image || item.image
                  }), setIsModify(!isModify)]}
                >
                  저장
                </Button>

                <Button
                  margin={'0 0 0 0'}
                  padding={'.4rem .5rem'}
                  radius={'.5rem'}
                  bgcolor={'#3f3b3f'}
                  color={'#ffffff'}
                  themecolor={'dark-gray'}
                  onClick={() => setIsModify(!isModify)}
                >
                  취소
                </Button>
              </Style.ModyfiAction>
              :
              <Style.ModyfiAction>
                <Button
                    margin={'0 .4rem 0 .4rem'}
                    padding={'.4rem .5rem'}
                    radius={'.5rem'}
                    bgcolor={'#3f3b3f'}
                    color={'#ffffff'}
                    themecolor={'dark-gray'}
                    onClick={() => setIsModify(!isModify)}
                >
                  수정
                </Button>

                <Button
                    margin={'0 0 0 0'}
                    padding={'.4rem .5rem'}
                    radius={'.5rem'}
                    bgcolor={'#3f3b3f'}
                    color={'#ffffff'}
                    themecolor={'dark-gray'}
                    onClick={() => _delete(item)}
                >
                  삭제
                </Button>
              </Style.ModyfiAction>
          }
        </Style.Action>
      </Style.Tree>

      {
        isAdd &&
          <Style.TreeItem isLevel={level}>
            <InputField
                type="text"
                id="newLabel"
                name="newLabel"
                value={item.newLabel}
                placeholder="이름"
                onChange={(e) => handleChange(e)}
            />

            {/*<InputField*/}
            {/*    type="text"*/}
            {/*    id="newUrl"*/}
            {/*    name="newUrl"*/}
            {/*    value={item.newUrl}*/}
            {/*    placeholder="경로"*/}
            {/*    onChange={(e) => handleChange(e)}*/}
            {/*/>*/}

            <Style.AddAction>
              <Button
                  margin={'0 0 0 0'}
                  padding={'1rem 4rem'}
                  radius={'.5rem'}
                  bgcolor={'#3f3b3f'}
                  color={'#ffffff'}
                  themecolor={'dark-gray'}
                  onClick={() => add(item)}
              >
                추가
              </Button>

              <Button
                  margin={'0 0 0 0'}
                  padding={'1rem 4rem'}
                  radius={'.5rem'}
                  bgcolor={'#3f3b3f'}
                  color={'#ffffff'}
                  themecolor={'dark-gray'}
                  onClick={() => setIsAdd(!isAdd)}
              >
                취소
              </Button>
            </Style.AddAction>
          </Style.TreeItem>
      }
    </Style.Container>
  )
}

export default Tree
